import Overview from "@/components/admin/Content/WebPages/AboutUs/MemberCountries/Overview";
import HeroSection from "@/components/admin/Content/WebPages/AboutUs/MemberCountries/HeroSection";
import FullPageSpinner from "@/components/ui/FullPageSpinner";
import { useWebPageForm } from "@/contexts/WebPageFormContext";

const MemberCountries = () => {
  const { pageData, isLoading } = useWebPageForm();

  if (isLoading) {
    return <FullPageSpinner />
  }

  return (
    <div className="flex flex-col gap-8 lg:gap-12 p-4 md:p-8 lg:p-12 xl:w-3/4 mx-auto">
      <HeroSection data={pageData?.MEMBER_COUNTRIES_BANNER ?? {
        sectionTag: 'MEMBER_COUNTRIES_BANNER',
        contentType: 'WITH_FILE',
        title: 'Member Countries Banner'
      }} />
      <Overview data={pageData?.MEMBER_COUNTRIES ?? {
        sectionTag: 'MEMBER_COUNTRIES',
        contentType: 'WITHOUT_FILE',
        title: 'Our Member Countries'
      }} />
    </div>
  )
}

export default MemberCountries